import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Avatar } from '@mui/material';
import { MODE } from '../../services/enum';
import { TextArea } from 'devextreme-react';
import { ComponentLoading } from '../loading';
import { useTranslation } from 'react-i18next';
import { SOFT_SILVER } from '../../config/color';
import { post } from '../../services/ApiServices';
import { TEXT } from '../../constant/textConstants';
import API_CONSTANT from '../../services/ApiConstant';
import { ROUTE } from '../../constant/routeConstants';
import { useDispatch, useSelector } from 'react-redux';
import TagSummaryModal from '../modal/TagSummaryModal';
import { SESSION_KEY } from '../../constant/appConstant';
import { useNavigate, useParams } from 'react-router-dom';
import { decrypt, encrypt } from '../../services/encryptDecryptService';
import { fetchApplicationDetails } from '../../store/application/action';
import { getFromAsync, generateLocalizedPath } from '../../services/utils';
import { fetchTagDetails, fetchTagListAPI } from '../../store/tags/action';

const TagDetails = () => {
  const { lang } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const userData = getFromAsync(SESSION_KEY?.USER_DATA);
  const { app, tag, comman } = useSelector((state) => state);

  const [tagText, setTagText] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showTagSummary, setShowTagSummary] = useState(false);

  useEffect(() => {
    const tagId = tag?.selectedTagData?.TagId || app?.appDetails?.TagId;

    if (tagId && tagId !== 0 && !tag?.tagDetails) {
      getTagDetails(tagId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tag?.selectedTagData?.TagId]);

  const getTagDetails = async (tagId) => {
    try {
      const res = await fetchTagDetails(dispatch, tagId);
      const decryptedData = decrypt(res?.data?.OutPutText);
      const appId = decryptedData?.TagDetail?.ApplicationId || 0;

      if (appId !== 0 && appId !== app?.appDetails?.ApplicationId) {
        getApplicationDetails(appId);
      }
    } catch (err) {}
  };

  const getApplicationDetails = async (appId) => {
    try {
      await fetchApplicationDetails(dispatch, appId);
    } catch (err) {}
  };

  const _onEditTag = (statusText) => {
    setIsLoading(true);

    const statusId = tag?.tagMasterData?.TagStatusList?.filter(
      (x) => x?.StatusText?.toLowerCase() === statusText?.toLowerCase(),
    );

    const obj = {
      TagText: tagText,
      TagStatus: statusId[0]?.StatusId,
      TagId: tag?.tagDetails?.TagDetail?.TagId,
      ToUser: tag?.tagDetails?.TagDetail?.ToUserId,
      TagSummary: tag?.tagDetails?.TagDetail?.TagSummary,
      DocumentId: tag?.tagDetails?.TagDetail?.DocumentId,
      DocumentNumber: tag?.tagDetails?.TagDetail?.DocumentNumber,
    };

    const apiObj = {
      Mode: MODE?.WEB_MODE,
      InputText: encrypt(obj),
      AppUserId: userData?.AppUserId,
    };

    post(API_CONSTANT.UPDATE_TAG, apiObj)
      .then((res) => {
        const data = decrypt(res.data.OutPutText);
        if (data?.IsUpdated) {
          setTagText('');
          setIsLoading(false);
          toast.success(data?.Message, { autoClose: 900 });
          fetchTagListAPI(dispatch);
          setTimeout(() => {
            navigate(generateLocalizedPath(lang, ROUTE?.TAG_LIST));
          }, 1000);
        }
      })
      .catch((e) => {
        setIsLoading(false);
        toast.error(e?.data?.ErrorMessage || e?.message || String(e));
      });
  };

  return (
    <div className="bg-white">
      {comman?.fetchingTagDetails || isLoading ? (
        <ComponentLoading loading={comman?.fetchingTagDetails || isLoading} className="pt-3" />
      ) : (
        <div>
          <div className="border-b-[1px] px-6 py-5">
            <div className="flex items-center gap-2">
              {tag?.tagDetails?.TagDetail?.TagStatus && (
                <p className="text-body1 w-max rounded-md bg-golden-yellow px-4 py-1.5 font-medium uppercase">
                  {tag?.tagDetails?.TagDetail?.TagStatus}
                </p>
              )}

              {tag?.tagDetails?.TagDetail?.TagNumber && (
                <p className="text-headingSm font-semibold text-dark-grey-black">
                  {tag?.tagDetails?.TagDetail?.TagNumber}
                </p>
              )}
            </div>
            <div className="mt-5 flex items-center gap-3.5">
              {tag?.tagDetails?.TagDetail?.DocumentNumber && (
                <div className="flex flex-col items-start">
                  <span className="text-body1 font-normal text-charcoal-grey">
                    {t(TEXT?.DOCUMENT_NUMBER)}
                  </span>
                  <p className="text-body2 font-semibold text-dark-grey-black">
                    {tag?.tagDetails?.TagDetail?.DocumentNumber}
                  </p>
                </div>
              )}
              {tag?.tagDetails?.TagDetail?.DocumentStatus && (
                <div className="flex flex-col items-start">
                  <span className="text-body1 font-normal text-charcoal-grey">
                    {t(TEXT?.DOCUMENT_STATUS)}
                  </span>
                  <p className="text-body2 font-semibold text-dark-grey-black">
                    <p className="w-max rounded-md bg-apricot-orange px-4 py-[2px] text-base font-medium capitalize">
                      {tag?.tagDetails?.TagDetail?.DocumentStatus}
                    </p>
                  </p>
                </div>
              )}
              {tag?.tagDetails?.TagDetail?.CreatedBy && (
                <div className="flex flex-col items-start">
                  <span className="text-body1 font-normal text-charcoal-grey">
                    {t(TEXT?.CREATED)} {t(TEXT?.BY)}
                  </span>
                  <p className="text-body2 font-semibold capitalize text-dark-grey-black">
                    {tag?.tagDetails?.TagDetail?.CreatedBy}
                  </p>
                </div>
              )}
            </div>
            {tag?.tagDetails?.TagDetail?.TagSummary && (
              <div className="mt-1 text-start">
                <span className="text-base font-normal text-charcoal-grey">
                  {t(TEXT?.TAG_SUMMARY)}
                </span>
                <p className="text-body2 font-semibold text-dark-grey-black">
                  {tag?.tagDetails?.TagDetail?.TagSummary}
                </p>
              </div>
            )}
          </div>

          <div className="flex items-start py-3">
            {tag?.tagDetails?.TagDetail?.TagContent?.length > 0 && (
              <div
                className={`${tag?.tagDetails?.TagDetail?.TagContent?.length > 0 ? 'w-1/2 border-r-[1px] border-r-light-grey px-5' : 'w-full px-3'} text-start`}
              >
                <p className="text-body2 font-semibold text-dark-grey-black">
                  {t(TEXT?.LATEST_ACTIVITY)}
                </p>
                {tag?.tagDetails?.TagDetail?.TagContent?.slice(0, 3)?.map((ele) => {
                  return (
                    <div className="flex w-full items-start space-x-2 py-2">
                      {/* Avatar Section */}
                      <div className="flex-shrink-0">
                        {ele?.AddUser !== null && (
                          <Avatar
                            alt={ele?.AddUser?.toUpperCase()}
                            src="/static/images/avatar/1.jpg"
                            sx={{
                              width: 32,
                              py: '4px',
                              px: '4px',
                              height: 32,
                              color: 'black',
                              fontSize: '1.2rem',
                              backgroundColor: SOFT_SILVER,
                            }}
                          />
                        )}
                      </div>

                      {/* User Content Section */}
                      <div className="flex w-full flex-col">
                        <div className="flex items-center justify-between">
                          {ele?.AddUser && (
                            <p className="text-body2 font-semibold !leading-[10px] text-black">
                              {ele?.AddUser}
                            </p>
                          )}
                          {ele?.AddDateTimeText && (
                            <p className="text-bodySm font-medium text-charcoal-grey">
                              {ele?.AddDateTimeText}
                            </p>
                          )}
                        </div>

                        {/* User Message */}
                        {ele?.Body && (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: `<div class="text-body1 text-black font-normal">${ele?.Body}</div>`,
                            }}
                            className="mt-1 whitespace-pre-wrap text-sm font-normal text-gray-700"
                          />
                        )}
                      </div>
                    </div>
                  );
                })}
                {tag?.tagDetails?.TagDetail?.TagContent?.length > 3 && (
                  <button
                    onClick={() => setShowTagSummary(true)}
                    className="mt-3 cursor-pointer text-sm font-medium text-main hover:underline"
                  >
                    {t(TEXT?.SHOW_MORE)}
                  </button>
                )}
              </div>
            )}
            {tag?.tagDetails?.TagDetail?.TranslationText !== '' && (
              <>
                <div
                  className={`${
                    tag?.tagDetails?.TagDetail?.TranslationText !== '' ? 'w-1/2' : 'w-full'
                  } px-3 text-start`}
                >
                  <p className="text-body2 font-semibold text-dark-grey-black">
                    {t(TEXT?.TRANSLATIONS)}
                  </p>
                  <p className="text-body1 pl-[2px] font-normal">
                    {tag?.tagDetails?.TagDetail?.TranslationText}
                  </p>
                </div>
              </>
            )}
          </div>

          <div className="mb-4 flex h-full w-full flex-col px-5 text-start">
            <TextArea
              value={tagText}
              minHeight={100}
              className="flex-grow"
              autoResizeEnabled={true}
              valueChangeEvent="change"
              placeholder="Enter tag text"
              onValueChanged={(e) => setTagText(e?.value)}
            />

            <div className="mt-4 flex justify-end gap-2">
              <button
                disabled={!tagText}
                onClick={() => _onEditTag('reply')}
                className={`${!tagText ? 'bg-gray-300' : 'bg-vivid-sky'} flex w-max items-center justify-center rounded-full px-6 py-2`}
              >
                <p className="text-sm font-medium text-black sm:text-base">{t(TEXT?.REPLY)}</p>
              </button>
              {tag?.tagDetails?.TagDetail?.TagStatus === 'Reply' && (
                <button
                  disabled={!tagText}
                  onClick={() => _onEditTag('close')}
                  className={`${!tagText ? 'bg-gray-300' : 'bg-bright-green'} flex w-max items-center justify-center rounded-full px-6 py-2`}
                >
                  <p className="text-sm font-medium text-black sm:text-base">{t(TEXT?.CLOSE)}</p>
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {showTagSummary && (
        <TagSummaryModal
          isOpen={showTagSummary}
          setIsOpen={setShowTagSummary}
          data={tag?.tagDetails?.TagDetail}
        />
      )}
    </div>
  );
};

export default TagDetails;
